/**
 * Лимиты видео теперь используют model ID напрямую (pricing/video/registry.js).
 * Маппинг не нужен — identity proxy для обратной совместимости с компонентами.
 */
export const MODEL_TO_LIMIT_KEY: Record<string, string> = new Proxy({} as Record<string, string>, {
  get(_target, prop: string) {
    return prop; // model ID = limit key
  },
  has() {
    return true;
  },
});
